import React from 'react';

import { deadlineForText } from '../../../../../utils';

import DiscountBlock from '../DiscountBlock';
import PriceBlock from '../PriceBlock';

const getPixInput = (props, plan, selectMethodPayment, i) => (
  <li key={props.paymentMethods[i].id} data-cy="method-pix">
    <button
      type="button"
      className={`${props.paymentMethods[i].class}  opcao`}
      onClick={() => selectMethodPayment(i, 'pix', props)}
    >
      <div className='mobile-payment-card'>
        <div className="icon-payment-mobile">
          <img src={`/assets/images/pagamento/${props.paymentMethods[i].img}.svg`} alt="pagamento" />
        </div>
        <div className="infos-payment-mobile">
          <h4 className="uppercase">{props.paymentMethods[i].name}</h4>
          <div className="text-payment-mobile">
            <div className="desc-info">
              O pagamento deve ser realizado em até {deadlineForText(props.paymentMethods[i].deadline)} após finalizar a
              compra.
            </div>

            <DiscountBlock
              paymentMethods={props.paymentMethods}
              purchaseSummary={props.purchaseSummary}
              paymentMethodSlug="pix"
            />
            <PriceBlock
              paymentMethods={props.paymentMethods}
              purchaseSummary={props.purchaseSummary}
              paymentMethodSlug="pix"
            />

            <div className="small-payment">Exclusivo para pagamento no Pix</div>
          </div>
        </div>
      </div>
      <div className="advancer-payment-mobile">
        <div></div>
      </div>
    </button>
  </li>
);

export default getPixInput;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/mobile/inputs/getPixInput.jsx